    <template>
    <div class="av-container">
        <div class="av-timebar" :style="timebarStyle">
            <!-- TODO: Hover Popup for time & comment -->
            <button class="av-time-button"
                    v-for="( {key, index, selected, style, canHover, hovered} ) of timebars"
                    :class="{selected, 'av-time-button--hoverable': canHover, 'av-time-button--hovered': hovered}"
                    :style="style"
                    :key="key"
                    @click="selectTimeframe($event, index)"
                    @mouseenter="onTimeframeEnter($event, index)"
                    @mouseleave="onTimeframeLeave($event, index)"/>
            <!--button class="av-time-button"
                    v-for="( {index, selected, style}, i ) of timebars"
                    :class="{selected}"
                    :style="style"
                    :key="i"
                    @click="selectTimeframe(index)"
                    @dblclick="selectTimeframe(index, true)"
                    @mouseenter="onTimeframeEnter($event, i)"
                    @mouseleave="onTimeframeLeave($event, i)"/-->
            <div class="av-timebar-tooltip-container"
                 v-if="tfTooltip"
                 :style="{left: tfTooltip.left, top: tfTooltip.top, width: tfTooltip.width}">
                <div class="av-timebar-tooltip">
                    {{ tfTooltip.from }} - {{ tfTooltip.to }}{{ tfTooltip.comment ? ': ' + tfTooltip.comment : '' }}
                </div>
            </div>
        </div>
        <div class="av-day-button-bar">
            <button class="av-day-button"
                    :class="{selected}"
                    v-for="{day, label, selected} of dayButtons"
                    :key="day">
                {{ label }}
            </button>
            <!--button class="av-day-button"
                    :class="{selected}"
                    v-for="{day, label, selected} of dayButtons"
                    :key="day"
                    @click="selectWeekday(day)"
                    @dblclick="selectWeekday(day, true)">
                {{ label }}
            </button-->
        </div>

        <!--div class="av-edit-container" :class="{open: somethingSelected}">
            <div class="av-edit-header">
                {{ weekdaysSelected ? 'Neue Verfügbarkeit erstellen:' : 'Verfügbarkeit bearbeiten:' }}
            </div>

            <div class="av-edit-section">
                <div class="av-time-input">
                    <div class="av-time-input-header">von</div>
                    <input type="time" v-model="inputData.fromTime" min="0" max="23" step="60" @change="inputChanged()">
                </div>

                <i class="av-time-arrow fas fa-chevron-right"/>

                <div class="av-time-input">
                    <div class="av-time-input-header">bis</div>
                    <input type="time" v-model="inputData.toTime" min="0" max="23" step="60" @change="inputChanged()">
                </div>
            </div>

            <hr style="background-color: var(--contrast-2);">

            <div class="av-edit-section">
                <span class="av-edit-label">Status:</span>
                <div class="av-state-select-container">
                    <button class="av-state-select-button"
                            v-for="button of stateButtons"
                            :key="button.value"
                            :style="inputData.state === button.value ? button.style : null"
                            @click="stateChanged(button.value)">
                        {{ button.label }}
                    </button>
                </div>
            </div>
            <div class="av-edit-section" v-if="inputData.state !== 0">
                <span class="av-edit-label">Begründung:</span>
                <input class="av-edit-input"
                       type="text"
                       placeholder="(optional)"
                       v-model="inputData.comment">
            </div>

            <hr style="background-color: var(--contrast-2);">

            <div class="av-edit-section" style="justify-content: flex-end; gap: 1rem;">
                <div style="margin-right: auto; display: flex; justify-content: flex-start; gap: 1rem;">
                    <button class="av-action-button"
                            v-if="inputData.state !== 0"
                            style="color: var(--md);"
                            @click="openTransferModal()">
                        {{ timeframesSelected === 1 ? 'Verfügbarkeit übertragen' : 'Verfügbarkeiten übertragen' }}
                    </button>
                    <button class="av-action-button"
                            v-if="canSelectedSimilarTimeframes()"
                            style="color: var(--md);"
                            @click="selectSimilarTimeframes()">
                        Ähnliche auswählen
                    </button>
                </div>
                <button class="av-action-button"
                        v-if="timeframesSelected > 0"
                        style="color: var(--col-error);"
                        @click="deleteTimeframesClicked()">
                    Löschen
                </button>
                <button class="av-action-button" @click="cancel()">Abbrechen</button>
                <button class="av-action-button" style="color: var(--md);" @click="saveClicked()">Speichern</button>
            </div>

        </div>

        <div class="av-edit-section" style="justify-content: flex-start; gap: 1rem; margin-top: 1rem;">
            <button class="av-action-button"
                    v-if="!somethingSelected"
                    style="color: var(--md);"
                    @click="openTransferModal()">
                Alle Verfügbarkeiten übertragen
            </button>
        </div>

        <div class="av-transfer-modal" v-if="transferModalOpen">
            <div class="av-transfer-modal-content">
                <div class="av-transfer-modal-header">
                    {{ timeframesSelected === 1 ? 'Verfügbarkeit übertragen' : 'Verfügbarkeiten übertragen' }}
                </div>
                <div class="av-transfer-modal-body">
                    <ul class="av-transfer-modal-list">
                        <li class="av-transfer-modal-list-entry" v-for="employee of employees" :key="employee.id"
                            @click="selectEmployee(employee.id)">
                            <img :src="employee.avatar"
                                 :alt="'Image of ' + employee.lastName + ' ' + employee.firstName"
                                 @error="onImageError($event)">
                            <span>{{ employee.lastName }} {{ employee.firstName }}</span>
                            <input type="checkbox" v-model="transferModalSelectedEmployees[employee.id]">
                        </li>
                    </ul>
                </div>
                <div class="av-transfer-modal-footer">
                    <button class="av-action-button" @click="transferModalOpen = false">Abbrechen</button>
                    <button class="av-action-button"
                            :style="{color: selectedTransferEmployees.length > 0 ? 'var(--md)' : 'var(--contrast-3)'}"
                            :disabled="selectedTransferEmployees.length === 0"
                            @click="transferTimeframes(somethingSelected)">
                        Übertragen ({{ selectedTransferEmployees.length }})
                    </button>
                </div>
            </div>
        </div-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from "moment";

const COLORS = {
    0: '#6d8d23',
    1: '#dc3545',
    3: '#fd7e14',
    4: '#17a2b8',
};

const END_OF_SUNDAY = 7 * 24 * 60;

export default {
    name: 'EmployeeAvailabilityEditor',
    props: {
        // availabilities: Array,
        employeeId: String,
    },
    data() {
        return {
            avBarData: [],
            newEntries: [],
            changedEntries: [],
            entriesToDelete: [],
            inputData: this.initInputData(),
            selectedWeekdays: [],
            hoveredEntry: null,
            tfTooltip: null,
            transferModalOpen: false,
            transferModalSelectedEmployees: {},
        };
    },
    mounted() {
        this.avBarData = this.availabilitiesToBarData(this.availabilities);
    },
    watch: {
        // availabilities(newVal) {
        //   this.avBarData = this.availabilitiesToBarData(newVal);
        // },
        employeeId() {
            this.cancel();
            this.transferModalOpen = false;
        },
        availabilities(newVal) {
            this.avBarData = this.availabilitiesToBarData(newVal);
        },
    },
    computed: {
        ...mapGetters([ 'employeeAvailabilityMap', 'employeeMap' ]),

        availabilities() {
            return Object.values(this.employeeAvailabilityMap || {})
                .filter(({ employeeId }) => employeeId === this.employeeId)
                .flatMap((availability) => {
                    let fromHr, fromMin;
                    if (typeof availability.from === 'string') {
                        [ fromHr, fromMin ] = availability.from.split(':');
                        [ fromHr, fromMin ] = [ fromHr, fromMin ].map(n => parseInt(n));
                    } else {
                        const momentFrom = moment(availability.from);
                        [ fromHr, fromMin ] = [ momentFrom.hours(), momentFrom.minutes() ];
                    }

                    let toHr, toMin;
                    if (typeof availability.to === 'string') {
                        [ toHr, toMin ] = availability.to.split(':');
                        [ toHr, toMin ] = [ toHr, toMin ].map(n => parseInt(n));
                    } else {
                        const momentTo = moment(availability.to);
                        [ toHr, toMin ] = [ momentTo.hours(), momentTo.minutes() ];
                    }

                    const from = fromHr * 60 + fromMin;
                    let to = toHr * 60 + toMin;
                    if (to <= from) to += 24 * 60;

                    const entries = [];

                    for (const wd of availability.weekDays) {
                        const start = from + (wd - 1) * 24 * 60;
                        const end = to + (wd - 1) * 24 * 60;
                        entries.push({
                            ...availability,
                            start,
                            end,
                            weekDay: wd,
                        });
                    }

                    return entries;
                })
                .sort((a, b) => a.start - b.start);
        },

        stateButtons() {
            return [
                { label: view.$t('pages.comp.available'), value: 0, style: { backgroundColor: COLORS[0], color: 'white' } },
                { label: this.$t('roster.comp.notAvailable'), value: 1, style: { backgroundColor: COLORS[1], color: 'white' } },
                { label: this.$t('roster.comp.undesired'), value: 3, style: { backgroundColor: COLORS[3], color: '#404040' } },
                { label: this.$t('roster.comp.preference'), value: 4, style: { backgroundColor: COLORS[4], color: '#404040' } },
            ];
        },

        somethingSelected() {
            return this.weekdaysSelected || this.timeframesSelected > 0;
        },

        weekdaysSelected() {
            return this.selectedWeekdays.length > 0;
        },

        timeframesSelected() {
            return this.avBarData.filter(([ _, d ]) => d.selected).length;
        },

        dayButtons() {
            // return this.$d();
            const weekdays = [ 1, 2, 3, 4, 5, 6, 7 ];
            const weekdaysDE = {
                1: this.$t('store.openingHours.weekDay1Short'),
                2: this.$t('store.openingHours.weekDay2Short'),
                3: this.$t('store.openingHours.weekDay3Short'),
                4: this.$t('store.openingHours.weekDay4Short'),
                5: this.$t('store.openingHours.weekDay5Short'),
                6: this.$t('store.openingHours.weekDay6Short'),
                7: this.$t('store.openingHours.weekDay7Short'),
            };
            return weekdays.map(d => ({
                day: d,
                label: weekdaysDE[d],
                selected: this.selectedWeekdays.includes(d),
            }));
        },

        barDataWithNewEntries() {
            let barData = [
                ...this.avBarData
                    .filter((entry) => {
                        const newEntry = entry[1].newEntry;
                        const hidden = entry[1].hidden;
                        const toDelete = this.entriesToDelete.find((e) => e[1] && e[1].id === entry[1].id);
                        return !newEntry && !toDelete && !hidden;
                    })
                    .map((entry, i) => {
                        for (const changedEntry of this.changedEntries) {
                            if (changedEntry[1].id !== undefined && changedEntry[1].id === entry[1].id) {
                                entry = changedEntry;
                            }
                        }
                        return entry;
                    }),
                ...this.newEntries,
            ].sort(([ a ], [ b ]) => a - b);

            barData = barData.flatMap((entry, index) => {
                const newEntries = [];
                const to = barData[index + 1] ? barData[index + 1][0] : END_OF_SUNDAY;
                let time = entry[0];
                while (time < to) {
                    const newTo = Math.min(time + 24 * 60, to);
                    // TODO: Push new entry for 00:00 of next day
                    newEntries.push([ time, {
                        ...entry[1],
                        startOf: newTo,
                    } ]);
                    time += 24 * 60;
                }
                return newEntries;
            });
            return barData;
        },

        timebarStyle() {
            const columns = 7 * 24 * 60 + 1;
            return {
                gridTemplateColumns: 'repeat(' + columns + ', 1fr)',
                gridTemplateRows: '1rem',
            };
        },

        timebars() {
            const timebars = [];

            // const visibleData = this.barDataWithNewEntries.map(([t, d], i) => [t, d, i]);
            // visibleData.sort(([ a ], [ b ]) => a - b);
            // if (visibleData.length === 0 || visibleData[0][0] !== 0)
            //     visibleData.unshift([0, {state: 0, id: 'entry0'}, 0]);
            // for (let i = 0; i < visibleData.length; i++) {
            //     const [time, data, index] = visibleData[i];
            //     const {newEntry, state, endOf, selected, selectedFromSunday} = data;
            //     const [endTime] = visibleData[i + 1] || [END_OF_SUNDAY];
            //
            //     const entry = {
            //         index,
            //         selected: selected || selectedFromSunday,
            //         hover: state !== 0,
            //         style: {
            //             backgroundColor: COLORS[state],
            //             gridColumn: `${time + 1} / ${endTime + 1}`,
            // width: `${100 * (endTime - time) / END_OF_SUNDAY}%`,
            // boxShadow: (newEntry && !endOf) ? 'inset 0 0 0 2px var(--contrast-2)' : 'none',
            // },
            // }

            // trim availabilities so overlapping ones are cut off
            const availabilities = [ ...this.availabilities ];

            for (let i = 0; i < availabilities.length; i++) {
                const availability = availabilities[i];

                let colFrom = availability.start + 1;
                // if (i > 0) {
                //     const prevAvailability = availabilities[i - 1];
                //     if (prevAvailability.start > availability.start && prevAvailability.end !== availability.end) {
                //         colFrom = prevAvailability.colTo;
                //     }
                // }

                let colTo = availability.end + 1;
                // if (i < availabilities.length - 1) {
                //     const nextAvailability = availabilities[i + 1];
                //     if (nextAvailability.start < availability.end && nextAvailability.start !== availability.start) {
                //         colTo = nextAvailability.start + 1;
                //     }
                // }
                if (colFrom > colTo) {
                    colTo = colTo + 24 * 60;
                }

                if (colTo > 7 * 24 * 60 + 1) {
                    const newColTo = colTo % (7 * 24 * 60);

                    const entryMonday = {
                        key: availability.id + '-' + availability.weekDay + '-wrapped',
                        index: i,
                        selected: false,
                        canHover: true,
                        hovered: this.hoveredEntry && this.hoveredEntry.id === availability.id,
                        style: {
                            backgroundColor: COLORS[availability.state],
                            gridColumn: `${ 1 } / ${ newColTo }`,
                            gridRow: '1 / 2',
                            // gridColumn: `${ 6 * 24 * 60 + 1 } / ${ 7 * 24 * 60 + 1 }`,
                            // boxShadow: (newEntry && !endOf) ? 'inset 0 0 0 2px var(--contrast-2)' : 'none',
                        },
                        colFrom,
                        colTo,
                    };
                    timebars.push(entryMonday);

                    colTo = 7 * 24 * 60 + 1;
                }
                const entry = {
                    key: availability.id + '-' + availability.weekDay,
                    index: i,
                    selected: false,
                    canHover: true,
                    hovered: this.hoveredEntry && this.hoveredEntry.id === availability.id,
                    style: {
                        backgroundColor: COLORS[availability.state],
                        gridColumn: `${ colFrom } / ${ colTo }`,
                        gridRow: '1 / 2',
                        // gridColumn: `${ 6 * 24 * 60 + 1 } / ${ 7 * 24 * 60 + 1 }`,
                        // boxShadow: (newEntry && !endOf) ? 'inset 0 0 0 2px var(--contrast-2)' : 'none',
                    },
                    colFrom,
                    colTo,
                };
                timebars.push(entry);
            }

            return timebars;
        },

        employees() {
            return Object.values(this.employeeMap || {})
                .filter(({ id, active }) => id !== this.employeeId && active)
                .sort((a, b) => a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName))
                .map((employee) => ({ ...employee, avatar: this.GetProfilePictureUrl(employee) }));
        },

        selectedTransferEmployees() {
            return Object.entries(this.transferModalSelectedEmployees)
                .filter(([ _, selected ]) => selected)
                .map(([ id ]) => this.employeeMap[id]);
        },
    },
    methods: {
        selectWeekday(weekday, dbl = false) {
            if (this.selectedWeekdays.length === 0)
                this.inputData = this.initInputData();

            const includesWD = this.selectedWeekdays.includes(weekday);
            if (includesWD)
                if (dbl)
                    this.selectedWeekdays = [];
                else
                    this.selectedWeekdays = this.selectedWeekdays.filter(d => d !== weekday);
            else if (dbl)
                this.selectedWeekdays = [ 1, 2, 3, 4, 5, 6, 7 ];
            else
                this.selectedWeekdays = [ ...this.selectedWeekdays, weekday ];

            this.deselectAllTimeframes();

            if (this.selectedWeekdays.length > 0) {
                this.inputChanged();
            } else {
                this.cancel();
            }
        },

        selectTimeframe(event, index, dbl = false) {
            if (index === null) return;
            const availability = this.availabilities[index];
            if (!availability) return;
            this.$emit('availabilitySelected', event, availability);
            // let avBarData = this.barDataWithNewEntries; //.filter(([ , { newEntry } ]) => !newEntry);
            // console.log('selectTimeframe', index, avBarData);
            // if (!avBarData[index]) return;
            // const selectedTime = avBarData[index][0];
            // const { state: selectedState, comment, selected } = avBarData[index][1];
            // if (selected) {
            //     deselect all timeframes and weekdays
                // this.deselectAllTimeframes();
                // this.selectedWeekdays = [];
                // return;
            // }
            //
            // avBarData = avBarData.map(([ t, d ], i) => [ t, {
            //     ...d,
            //     selected: dbl
            //         if dbl: select every time frame that matches the type and time, regardless of the day
                    // ? d.state === selectedState && t % (24 * 60) === selectedTime % (24 * 60)
                    // : i === index,
                // selectedFromSunday: false,
            // } ]);
            //
            // this.avBarData = avBarData;
            // this.selectedWeekdays = [];
            //
            // update input data
            // const fromHr = Math.floor((selectedTime / 60) % 24);
            // const fromMin = selectedTime % 60;
            // const fromTime = fromHr.toString().padStart(2, '0') + ':' + fromMin.toString().padStart(2, '0');
            //
            // const nextTF = avBarData[index + 1];
            // let toTime = '00:00';
            // if (nextTF) {
            //     const nextTime = nextTF[0];
            //     const toHr = Math.floor((nextTime / 60) % 24);
            //     const toMin = nextTime % 60;
            //     toTime = (toHr % 24).toString().padStart(2, '0') + ':' + toMin.toString().padStart(2, '0')
            // }
            // this.inputData = {
            //     fromTime,
            //     toTime,
            //     state: selectedState,
            //     comment,
            // };
        },

        deselectAllTimeframes() {
            this.avBarData = this.avBarData.map(([ t, d ]) => [ t, {
                ...d,
                selected: false,
                selectedFromSunday: false
            } ]);
        },

        canSelectedSimilarTimeframes() {
            const selected = this.avBarData.filter(([ _, { selected } ]) => !!selected);
            if (selected.length !== 1) return false;
            const [ selectedTime, selectedData ] = selected[0];
            const selectableTFs = this.avBarData.filter(([ t, d ]) => d.state === selectedData.state && t % (24 * 60) === selectedTime % (24 * 60));
            return selectableTFs.length > 1;
        },

        selectSimilarTimeframes() {
            const selectedTF = this.avBarData.find(([ _, d ]) => !!d.selected);
            if (!selectedTF) return;
            const [ selectedTime, selectedData ] = selectedTF;
            this.avBarData = this.avBarData.map(([ t, d ], i) => [ t, {
                ...d,
                selected: d.state === selectedData.state && t % (24 * 60) === selectedTime % (24 * 60),
                selectedFromSunday: false,
            } ]);
        },

        GetProfilePictureUrl(employee) {
            if (!employee || !employee.employeePicture || !employee.employeePicture.server) return '/img/default.jpg';
            return employee.employeePicture.server + '/api/file?id=' + employee.employeePicture.fileId + '&accessToken=' + employee.employeePicture.accessToken + '&thumb=small' + '&time=' + Date.now();
        },

        onImageError(event) {
            event.target.src = '/img/default.jpg';
        },

        openTransferModal() {
            this.transferModalOpen = true;
            this.transferModalSelectedEmployees = {};
        },

        selectEmployee(employeeId) {
            this.$set(this.transferModalSelectedEmployees, employeeId, !this.transferModalSelectedEmployees[employeeId]);
        },

        async transferTimeframes(onlySelected = false) {
            // If onlySelected is false, replace all available timeframes from target employee with the ones from current employee
            if (!onlySelected) {
                // Merge all timeframes before transfer to remove duplicates
                this.avBarData = this.mergeBarData();
                const availabilities = this.barDataToAvailabilities(this.avBarData);
                const promises = [];
                for (const employee of this.selectedTransferEmployees) {
                    promises.push(this.replaceAvailabilities(availabilities, employee.id));
                }
                try {
                    await Promise.all(promises);
                    const empCount = this.selectedTransferEmployees.length;
                    const empText = (empCount === 1 ? '' : empCount + ' ') + this.$tc('pages.comp.employeeGendered', empCount);
                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('pages.comp.sendAvailabilities', [availabilities.length, empText]));
                } catch (e) {
                    console.error(e);
                    this.$helpers.error(this.$t('global.notifications.error'), this.$t('pages.comp.sendAvailabilitiesError'));
                } finally {
                    this.transferModalOpen = false;
                }
                return;
            }

            const selectedTFs = this.avBarData.flatMap((entry, index, arr) => {
                if (entry[1].selected) {
                    let i = index + 1;
                    if (entry[1].newEntry) {
                        // if new entry, select until end, as there may be some hidden entries in between
                        while (arr[i][1].endOf !== entry[0]) {
                            i++;
                        }
                        // update entry to reflect comment and state
                        entry[1] = {
                            ...entry[1],
                            comment: this.inputData.comment,
                            state: this.inputData.state,
                        };
                    }
                    return [ entry, arr[i] ];
                } else {
                    return [];
                }
            });
            const availabilitiesToTransfer = this.barDataToAvailabilities(selectedTFs);

            const promises = [];
            for (const av of availabilitiesToTransfer) {
                for (const employee of this.selectedTransferEmployees) {
                    promises.push(this.createEmployeeAvailability(av, employee.id));
                }
            }
            try {
                await this.saveClicked();
                await Promise.all(promises);
                const empCount = this.selectedTransferEmployees.length;
                const empText = (empCount === 1 ? '' : empCount + ' ') + this.$tc('pages.comp.employeeGendered', empCount);
                this.$helpers.success(this.$t('global.notifications.success'), this.$t('pages.comp.sendAvailabilities', [availabilitiesToTransfer.length, empText]));
            } catch (e) {
                console.error(e);
                this.$helpers.error(this.$t('global.notifications.error'), this.$t('pages.comp.sendAvailabilitiesError'));
            } finally {
                this.transferModalOpen = false;
            }
        },

        onTimeframeEnter(event, visibleIndex) {
            const availability = this.availabilities[visibleIndex];
            const fromHr = Math.floor(availability.start % (24 * 60) / 60);
            const fromMin = availability.start % 60;
            const toHr = Math.floor(availability.end % (24 * 60) / 60);
            const toMin = availability.end % 60;

            this.hoveredEntry = availability;

            const rect = event.target.getBoundingClientRect();
            this.tfTooltip = {
                from: `${ fromHr.toString().padStart(2, '0') }:${ fromMin.toString().padStart(2, '0') }`,
                to: `${ toHr.toString().padStart(2, '0') }:${ toMin.toString().padStart(2, '0') }`,
                comment: availability.comment || null,
                top: rect.top - 32 + 'px',
                left: (rect.left - 100) + 'px',
                width: (rect.width + 200) + 'px',
            };
        },
        onTimeframeLeave(event, index) {
            this.tfTooltip = null;
            this.hoveredEntry = null;
        },

        stateChanged(state) {
            this.$set(this.inputData, 'state', state);
            this.inputChanged();
        },

        inputChanged() {
            // const barData = this.avBarData.map(entry => [ entry[0], { ...entry[1], hidden: false } ])
            //     .filter(([ _, { newEntry } ]) => !newEntry);

            if (!this.somethingSelected) {
                return;
            }

            let barData = [ ...this.avBarData ];
            barData = [ ...barData ].sort(([ a ], [ b ]) => a - b);
            const newData = [];

            let [ fromHr, fromMin ] = this.inputData.fromTime.split(':');
            [ fromHr, fromMin ] = [ parseInt(fromHr), parseInt(fromMin) ];
            let [ toHr, toMin ] = this.inputData.toTime.split(':');
            [ toHr, toMin ] = [ parseInt(toHr), parseInt(toMin) ];
            if ((toHr * 60 + toMin) <= (fromHr * 60 + fromMin)) toHr += 24;

            const { state, comment } = this.inputData;

            if (this.weekdaysSelected) {
                this.addEntry(this.selectedWeekdays, fromHr, fromMin, toHr, toMin, state, comment, true);
                // for (const wd of this.selectedWeekdays) {
                //     const fromVal = ( wd - 1 ) * 24 * 60 + fromHr * 60 + fromMin;
                //     const toVal = ( wd - 1 ) * 24 * 60 + toHr * 60 + toMin;
                //     // Wrap around sunday
                //     if (toVal > END_OF_SUNDAY) {
                //         newData.push([ fromVal, {
                //             state,
                //             comment,
                //             startOf: END_OF_SUNDAY,
                //             newEntry: true,
                //             selected: true
                //         } ]);
                //         // set barData[0] to new state
                //         newData.push([ 0, {
                //             state,
                //             comment,
                //             startOf: toVal - END_OF_SUNDAY,
                //             newEntry: true,
                //             selectedFromSunday: true,
                //         } ]);
                //         // inset end from the state
                //         newData.push([ toVal - END_OF_SUNDAY, { state: 0, newEntry: true, endOf: 0 } ]);
                //     } else {
                //         newData.push([ fromVal, { state, comment, startOf: toVal, newEntry: true, selected: true } ]);
                //         newData.push([ toVal, { state: 0, newEntry: true, endOf: fromVal } ]);
                //     }
                // }
            } else {
                const selectedTimeframes = this.barDataWithNewEntries.filter(([ _, d ]) => d.selected);
                for (const [ tStart, dStart ] of selectedTimeframes) {
                    const wd = Math.floor(tStart / (24 * 60));
                    const fromVal = wd * 24 * 60 + fromHr * 60 + fromMin;
                    const toVal = wd * 24 * 60 + toHr * 60 + toMin;

                    this.addEntry([ wd + 1 ], fromHr, fromMin, toHr, toMin, state, comment, true);
                    //
                    // newData.push([ fromVal, { ...dStart, state: this.inputData.state, newEntry: true, startOf: toVal } ]);
                    // newData.push([ toVal, { state: 0, newEntry: true, endOf: tStart } ]);
                    // wrap around sunday
                    // if (toVal > END_OF_SUNDAY) {
                    //     newData.push([ fromVal, {
                    //         state,
                    //         comment,
                    //         startOf: END_OF_SUNDAY,
                    //         newEntry: true,
                    //         selected: true
                    //     } ]);
                    //     set barData[0] to new state
                    // newData.push([ 0, {
                    //     state,
                    //     comment,
                    //     startOf: toVal - END_OF_SUNDAY,
                    //     newEntry: true,
                    //     selectedFromSunday: true,
                    // } ]);
                    // inset end from the state
                    // newData.push([ toVal - END_OF_SUNDAY, { state: 0, endOf: 0, newEntry: true } ]);
                    // } else {
                    //     newData.push([ fromVal, { state, comment, startOf: toVal, newEntry: true, selected: true } ]);
                    //     newData.push([ toVal, { state: 0, endOf: fromVal, newEntry: true } ]);
                    // }
                }
                // remove selected timeframes, because new entries are added "on top"
                barData = barData.filter(([ _, d ]) => !d.selected);
            }

            // this.avBarData = this.mergeBarData(barData, newData);
        },

        mergeBarData(barData = null, newData = []) {
            if (barData === null) barData = this.avBarData;
            barData = barData.filter(([ , d ]) => !d.newEntry).map(([ t, d ]) => [ t, { ...d, hidden: false } ]);
            barData = [ ...barData, ...newData ];
            barData.sort(([ a ], [ b ]) => a - b);
            // check if entries end at the same time, swap newEntries to be at a higher index
            barData.sort(([ a, d1 ], [ b, d2 ]) => a === b ? (!d1.newEntry ? -1 : 1) : 0);

            const toDelete = new Set();
            const toHide = new Set();
            for (let i = 0; i < barData.length; i++) {
                const [ t, data ] = barData[i];
                // Remove existing redundant entries
                if (i > 0) {
                    const [ prevT, prevData ] = barData[i - 1];
                    if (data.state === prevData.state && data.comment === prevData.comment && !data.newEntry && !prevData.newEntry) {
                        // Entry is redundant
                        toDelete.add(i);
                    }
                }
                // Trim/hide existing overlapping entries if newEntry === true
                if (data.newEntry && (data.endOf === undefined || data.endOf === null)) {
                    for (let j = i + 1; j < barData.length; j++) {
                        let [ t2, data2 ] = barData[j];
                        // trim time bar if new entry ends between existing timeframes
                        if (data2.endOf === t) {
                            if (t2 >= barData[j - 1][0]) {
                                // If time is not the same, set the end state to the old state
                                data2.state = barData[j - 1][0] === t ?
                                    data.state === 0
                                        ? 1 : 0
                                    : barData[j - 1][1].state;
                                data2.comment = barData[j - 1][1].comment;
                            }
                            break;
                        } else {
                            toHide.add(j);
                        }
                    }
                }
            }

            // hide/remove entries
            for (const i of toHide) {
                barData[i][1].hidden = true;
            }
            barData = barData.filter((_, i) => !toDelete.has(i));

            // split entries > 24h
            const toInsert = [];
            for (let i = 0; i < barData.length; i++) {
                const [ start, dStart ] = barData[i];
                const [ end ] = barData[i + 1] || [ END_OF_SUNDAY ];
                let newStart = start;
                while (end > newStart + 24 * 60) {
                    newStart += 24 * 60;
                    toInsert.push({ at: i + 1, barData: [ newStart, { ...dStart, id: dStart.id + '-i-' + i } ] });
                }
            }
            for (const { at, barData: data } of toInsert.reverse()) {
                barData.splice(at, 0, data);
            }

            return barData;
        },

        addEntry(weekdays, fromHr, fromMin, toHr, toMin, state, comment, temporary = true) {
            const barData = [ ...this.avBarData ];
            const newEntries = [];
            let changedEntries = [];
            const toDelete = [];

            for (const weekday of weekdays) {
                const wd = weekday === 0 ? 6 : weekday - 1;
                const fromVal = wd * 24 * 60 + fromHr * 60 + fromMin;
                const toVal = wd * 24 * 60 + toHr * 60 + toMin;

                if (toVal > END_OF_SUNDAY) {
                    newEntries.push([ 0, {
                        state,
                        comment,
                        startOf: toVal - END_OF_SUNDAY,
                        selected: true,
                    } ]);
                    newEntries.push([ toVal - END_OF_SUNDAY, {
                        state: state === 0 ? 1 : 0,
                        endOf: END_OF_SUNDAY,
                    } ]);

                    const entriesBetween = this.findEntriesBetween(barData, 0, toVal - END_OF_SUNDAY);
                    for (const entryBetween of entriesBetween) {
                        toDelete.push(entryBetween);
                    }
                }

                const newTo = toVal > END_OF_SUNDAY ? END_OF_SUNDAY : toVal;

                if (state === 0) {
                    const entriesBetweenStart = this.findEntriesBetween(barData, 0, fromVal);
                    if (entriesBetweenStart.length > 1) {
                        let entryBefore = entriesBetweenStart[entriesBetweenStart.length - 1];
                        if (entryBefore[0] === fromVal)
                            entryBefore = entriesBetweenStart[entriesBetweenStart.length - 2];
                        entryBefore[1].state = 1;
                        changedEntries.push(entryBefore)
                    }
                }
                newEntries.push([ fromVal, {
                    state,
                    comment,
                    startOf: newTo,
                    selected: true,
                } ]);
                newEntries.push([ newTo, {
                    state: state === 0 ? 1 : 0,
                    endOf: fromVal,
                } ]);
                const entriesBetween = this.findEntriesBetween(barData, fromVal, newTo);
                for (const entryBetween of entriesBetween) {
                    toDelete.push(entryBetween);
                    console.log(entryBetween);
                }
            }

            // changedEntries = barData.map((entry) => {
            //     if (state === 0)
            //         entry[1].state = 1;
            //     return entry;
            // });

            this.avBarData = barData;
            this.newEntries = newEntries;
            this.changedEntries = changedEntries;
            this.entriesToDelete = toDelete;
        },

        findEntriesBetween(barData, fromVal, toVal) {
            const entries = [];
            for (let i = 0; i < barData.length; i++) {
                const entry = barData[i];
                if (entry[0] >= fromVal && entry[0] <= toVal) {
                    entries.push(entry);
                }
            }
            return entries;
        },

        availabilitiesToBarData(availabilities) {
            const availabilitiesMapped = availabilities.flatMap((availability) => {
                let fromHr, fromMin;
                if (typeof availability.from === 'string') {
                    [ fromHr, fromMin ] = availability.from.split(':');
                    [ fromHr, fromMin ] = [ parseInt(fromHr), parseInt(fromMin) ];
                } else {
                    fromHr = availability.from.hour();
                    fromMin = availability.from.minute();
                }
                let toHr, toMin;
                if (typeof availability.to === 'string') {
                    [ toHr, toMin ] = availability.to.split(':');
                    [ toHr, toMin ] = [ parseInt(toHr), parseInt(toMin) ];
                } else {
                    toHr = availability.to.hour();
                    toMin = availability.to.minute();
                }
                const splitAvailabilities = [];
                for (const weekday of availability.weekDays) {
                    const weekdayFromZero = weekday - 1;
                    const toDay = fromHr * 60 + fromMin >= toHr * 60 + toMin ? weekday : weekdayFromZero;
                    const fromNum = weekdayFromZero * 24 * 60 + fromHr * 60 + fromMin;
                    let toNum = toDay * 24 * 60 + toHr * 60 + toMin;
                    splitAvailabilities.push({
                        fromNum,
                        toNum,
                        availability: { ...availability, id: availability.id + '-wd-' + weekday }
                    });
                }
                return splitAvailabilities;
            });
            let barData = [];
            for (let { fromNum, toNum, availability } of availabilitiesMapped) {
                const state = availability.state;
                // convert to absolute number for comparison
                let wrappedToMonday = false;
                if (toNum > END_OF_SUNDAY) {
                    toNum -= END_OF_SUNDAY;
                    wrappedToMonday = true;
                }

                const barEntry = { state, newEntry: false, comment: availability.comment, id: availability.id };
                if (wrappedToMonday) {
                    barData[0][1] = barEntry;
                }
                if (toNum) {
                    let endState = 0;
                    let endComment = undefined;
                    barData = [
                        ...barData,
                        [ fromNum, barEntry ],
                    ]
                    // search for an availability that starts right at the end
                    const overlappingAV = availabilitiesMapped.find(({ fromNum: fn }) => fn === toNum);
                    if (!overlappingAV) {
                        // if no av found, insert end
                        barData = [
                            ...barData,
                            [ toNum, {
                                state: endState,
                                comment: endComment,
                                newEntry: false,
                                id: availability.id + '-end'
                            } ],
                        ];
                    }
                    barData = barData.sort(([ a ], [ b ]) => a - b);
                }
            }
            if (!barData[0] || barData[0][0] > 0)
                barData = [ [ 0, { state: 0, newEntry: false, id: 'entry0' } ], ...barData ];

            return this.mergeBarData(barData);
        },

        barDataToAvailabilities(barData) {
            barData = [ ...barData ].sort(([ a ], [ b ]) => a - b);

            const availabilities = [];
            for (let i = 0; i < barData.length; i++) {
                const [ start, d ] = barData[i];
                if (d.state === 0) continue; // exclude state === available
                const [ end ] = barData[i + 1] || [ END_OF_SUNDAY ];

                // Check if end > start + 24hr and create new entries
                let startNew = start;
                let endNew;
                do {
                    endNew = (end > startNew + 24 * 60) ? startNew + 24 * 60 : end;
                    // const key = `${ startNew % (24 * 60) }:${ endNew % (24 * 60) }:${ d.state }:${ d.comment }`;
                    const wd = Math.floor(startNew / (24 * 60)) + 1;
                    // let { weekDays: currentWeekDays } = availabilities[key] || { weekDays: [] };
                    // currentWeekDays = [ ...currentWeekDays, wd ];
                    availabilities.push(this.createAvailability([ wd ], startNew, endNew, d.comment, d.state, d.id));
                    startNew += 24 * 60;
                } while (end > startNew);
            }
            return availabilities;
        },

        createAvailability(weekDays, fromMins, toMins, comment = '', state = 1, id = null) {
            const from = Math.floor(fromMins / 60 % 24).toString().padStart(2, '0') + ':' + (fromMins % 60).toString().padStart(2, '0');
            const to = Math.floor(toMins / 60 % 24).toString().padStart(2, '0') + ':' + (toMins % 60).toString().padStart(2, '0');
            const av = {
                storeId: this.$store.state.storeId,
                employeeId: this.employeeId,
                from,
                to,
                comment,
                weekDays,
                state,
                factor: 1,
                exclusive: true,
                spotId: null,
            };
            if (id !== undefined && id !== null)
                av.id = id;
            return av;
        },

        initInputData() {
            const currentDate = new Date();
            const toDate = new Date(currentDate.getTime() + 4 * 60 * 60 * 1000); // 4 hr from now
            let fromHr = currentDate.getHours().toString();
            if (fromHr.length === 1) fromHr = '0' + fromHr;
            let toHr = toDate.getHours().toString();
            if (toHr.length === 1) toHr = '0' + toHr;
            return {
                fromTime: fromHr + ':00',
                toTime: toHr + ':00',
                comment: '',
                state: 1,
            };
        },

        deleteTimeframesClicked() {
            this.avBarData = this.mergeBarData(this.avBarData.filter(([ _, d ]) => !d.selected));
            const availabilities = this.barDataToAvailabilities(this.avBarData);
            this.replaceAvailabilities(availabilities)
                .then(response => {
                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('global.ui.deletedX', [this.$t('pages.comp.availability')]));
                })
                .catch((error) => {
                    console.error(error);
                    this.$helpers.error(this.$t('global.notifications.error'), this.$t('global.ui.deletedErrorX', [this.$t('pages.comp.availability')]));
                });
        },

        cancel() {
            this.avBarData = this.avBarData = this.availabilitiesToBarData(this.availabilities);
            this.newEntries = [];
            this.changedEntries = [];
            this.entriesToDelete = [];
            this.selectedWeekdays = [];
            this.deselectAllTimeframes();
        },

        saveClicked() {
            this.avBarData = [ ...this.barDataWithNewEntries ];
            this.newEntries = [];
            this.entriesToDelete = [];
            this.changedEntries = [];
            this.selectedWeekdays = [];
            this.deselectAllTimeframes();
            this.avBarData = this.mergeBarData();
            const availabilities = this.barDataToAvailabilities(this.avBarData);
            this.replaceAvailabilities(availabilities)
                .then(response => {
                    this.$helpers.success(this.$t('global.notifications.success'), this.$t('global.ui.editedX', [this.$t('pages.comp.availability')]));
                })
                .catch((error) => {
                    console.error(error);
                    this.$helpers.error(this.$t('global.notifications.error'), this.$t('global.ui.editedErrorX', [this.$t('pages.comp.availability')]));
                });
        },

        //
        // HTTP

        async replaceAvailabilities(availabilities, employeeId = null) {
            availabilities = availabilities.map((av) => ({ ...av, employeeId: employeeId || this.employeeId }));

            let resultingAvailabilities = [];
            if (availabilities.length == 0) {
                //NEED TO CALL DELETE ANY BY EMPLOYEE ID INSTEAD OF REPLACE
                const response = await this.axios({
                    method: 'DELETE',
                    headers: { 'AUTHORIZATION': `bearer ${ this.$store.state.jwt }` },
                    url: '/api/sec/employeeavailability/any/employee',
                    params: { storeId: this.$store.state.storeId, employeeId: this.employeeId },
                });
            } else {
                const response = await this.axios({
                    method: 'POST',
                    headers: { 'AUTHORIZATION': `bearer ${ this.$store.state.jwt }` },
                    url: '/api/sec/employeeavailability/replace',
                    params: { storeId: this.$store.state.storeId },
                    data: { requests: [ ...availabilities ] },
                });
                resultingAvailabilities = response.data;
            }


            // delete old availabilities
            const employeeAvailabilities = Object.values(this.employeeAvailabilityMap)
                .filter(({ employeeId: eid }) => eid === (employeeId || this.employeeId));

            for (const availability of employeeAvailabilities) {
                if (availability.id)
                    this.$store.commit('deleteEmployeeAvailabilityMapEntry', { ...availability });
            }

            // insert new availabilities
            for (const availability of resultingAvailabilities) {
                this.$store.commit('setEmployeeAvailabilityMapEntry', { ...availability });
            }

        },

        async createEmployeeAvailability(av, employeeId) {
            const payload = { ...av, employeeId };
            try {
                const response = await this.axios({
                    method: 'POST',
                    headers: { 'AUTHORIZATION': `bearer ${ this.$store.state.jwt }` },
                    url: '/api/sec/employeeavailability',
                    params: { storeId: this.$store.state.storeId },
                    data: payload,
                });
                this.$store.commit('setEmployeeAvailabilityMapEntry', { ...payload, id: response.data.data.id });
                return response;
            } catch (error) {
                console.error(this.$t('global.notifications.error'), error);
                throw error;
            }
        },
    },
}
</script>

<style scoped>
.av-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;

    padding: 1rem 0;
    margin-bottom: 1rem;
}

.av-timebar {
    display: grid;
    width: 100%;
    height: 1rem;
    overflow: hidden;
    background-color: #6d8d23;
}

.av-time-button {
    height: 1rem;
    margin: 0;
    padding: 0;
    outline: none;
    border: none;
}

.av-time-button--hoverable:hover, .av-time-button--hovered {
    box-shadow: inset 0 0 4px 1px var(--contrast-2);
    z-index: 1;
}

.av-time-button.selected {
    outline: 2px solid var(--contrast-3);
    outline-offset: -2px;
}

.av-timebar-tooltip-container {
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: center;
}

.av-timebar-tooltip {
    color: var(--contrast-4);
    background-color: var(--contrast-1);
    padding: 0.125rem 0.25rem;
}

.av-day-button-bar {
    display: flex;
    justify-content: stretch;
    background-color: var(--contrast-2);
    gap: 2px;
    padding: 2px;
    padding-top: 0;
}

.av-day-button {
    flex: 1;

    padding: 0.25rem 0.5rem;
    margin: 0;
    border: none;
    /*border-bottom: 2px solid var(--contrast-0);*/
    outline: none;

    cursor: default;
    background-color: var(--bg);
    color: var(--contrast-4);
}

.av-day-button.selected {
    border-bottom: 2px solid var(--contrast-5);
    background-color: var(--contrast-1);
}

.av-edit-container {
    display: flex;
    flex-direction: column;

    overflow: hidden;
    max-height: 0;
    transition: max-height 125ms ease-in-out;
}

.av-edit-container.open {
    max-height: 1000px;
}

.av-edit-header {
    text-align: left;
    font-family: DistrictProBold, sans-serif;
    margin: 1rem;
    color: var(--contrast-4);
}

.av-edit-section {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: stretch;
    margin: 0.5rem;
}

.av-edit-section > div {
    flex: 1;
}

.av-edit-label {
    font-family: "District Pro", sans-serif;
    font-size: 1rem;
    color: var(--contrast-4);
}

.av-time-input {
}

.av-time-input-header {
    color: var(--contrast-5);
    font-family: "District Pro", sans-serif;
    font-size: 1.25rem;
    margin: 0;
}

.av-time-input > input {
    border: none;
    outline: none;
    background-color: transparent;
    box-shadow: none;
    font-family: DistrictProBold, sans-serif;
    font-size: 2rem;
    color: var(--md);
    text-align: center;
}

.av-time-input > input::-webkit-calendar-picker-indicator {
    display: none;
}

.av-time-input > span {
    font-family: DistrictProBold, sans-serif;
    font-size: 2rem;
    color: var(--md);
}

.av-time-arrow {
    color: var(--contrast-3);
    font-size: 1.75rem;
    align-self: center;
    cursor: default;
}

.av-state-select-container {
    border: 1px solid var(--contrast-3);
    background-color: var(--contrast-3);
    color: var(--contrast-4);
    display: flex;
    gap: 1px;
    max-width: 75%;
    margin-left: auto;
}

.av-state-select-button {
    flex: 1;
    background-color: var(--contrast-0);
    color: var(--contrast-4);
    outline: none;
    box-shadow: none;
    border: none;
}

.av-state-select-button:focus {
    border-radius: 0;
    outline: none;
}

.av-edit-input {
    background-color: var(--contrast-0);
    margin-left: auto;
    width: 50%;
    border: 1px solid var(--contrast-3);
    border-radius: 0;
    outline: none;
    box-shadow: none;
    color: var(--contrast-4);
}

.av-action-button {
    border: none;
    outline: none;
    box-shadow: none;
    background-color: transparent;
    color: var(--contrast-7);
}

.av-transfer-modal {
    position: fixed;
    z-index: 10;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    width: 100%;
    max-width: 400px;
    height: 50%;
    background-color: var(--bg);
    box-shadow: 4px 4px 5px 3px rgba(0, 0, 0, 0.2), 0 0 0 1px var(--contrast-3);
}

.av-transfer-modal-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    height: 100%;
}

.av-transfer-modal-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    color: var(--md);
}

.av-transfer-modal-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    flex: 1;
    padding: 0 1rem;
    overflow: auto;
}

.av-transfer-modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    gap: 0.5rem;
}

.av-transfer-modal-list {
    list-style: none;
}

.av-transfer-modal-list-entry {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    align-items: center;
    padding: 0.5rem;
    gap: 1rem;
    border-bottom: 1px solid var(--contrast-3);
}

.av-transfer-modal-list-entry:hover {
    background-color: var(--contrast-1);
}

.av-transfer-modal-list-entry > img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background-color: var(--contrast-3);
}

.av-transfer-modal-list-entry > span {
    flex: 1;
    text-align: left;
    color: var(--contrast-4);
}

.av-transfer-modal-list-entry > input {
    accent-color: var(--md);
    width: 1rem;
    height: 1rem;
}
</style>
